import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VFooter,{staticClass:"justify-center",style:(_vm.getThemeStyle),attrs:{"height":"40","absolute":""}},[_c('div',{staticClass:"title font-weight-light text--lighten-1 text-center"},[_vm._v(" Created By Kenny [+27 76 243 9441] "+_vm._s(!_vm.isMobile ? "    ©" + new Date().getFullYear() : "")+" — "+_vm._s(!_vm.isMobile ? _vm.getAppName : "")+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }